import { Product } from "../map-factory";
import * as RichMarker from 'js-rich-marker';
declare var google;

export class GoogleMapsProduct implements Product {
    public static map: any;
    marker: any = null;
    nearestCompetitors: any = [];
    startMarker;
    finishMarker;

    private static instance: GoogleMapsProduct;

    config = {
        marker: null,
        polyLines: null,
        polyDestinations: [],
        prevDestination: null,
        map: null,
        colored: false,
        hLines: null
    };

    clearMeMarker() {
        this.marker = null;
    }

    private constructor(map) {
        console.log('GoogleMapsProduct, map: ', map);
        GoogleMapsProduct.map = map;
    }

    public static getInstance(map): GoogleMapsProduct {
        if (!GoogleMapsProduct.instance) {
            GoogleMapsProduct.instance = new GoogleMapsProduct(map);
        }
        GoogleMapsProduct.map = map;

        return GoogleMapsProduct.instance;
    }

    newPoly() {
        if (this.getPolyLines()) {
            this.getPolyLines().setMap(null);
        }
        this.setPolyDestinations([]);
    }

    addPolyDestination(coords, index?: any) {
        if (this.getMap()) {

            coords.latitude = coords._latitude || coords.latitude || coords.coords.latitude;
            coords.longitude = coords._longitude || coords.longitude || coords.coords.longitude;

            if (!index) {
                this.getPolyDestinations().push(new google.maps.LatLng(coords.latitude, coords.longitude));
            } else {
                this.getPolyDestinations()[index] = new google.maps.LatLng(coords.latitude, coords.longitude);
            }
        }
    }

    positionMarker(o) {
        if (this.getMap() && typeof o !== "undefined" && o) {

            let position = new google.maps.LatLng(o.coords.latitude, o.coords.longitude);

            if (!this.marker) {
                let map = this.getMap();
                console.log('map: ' + map);
                // let RichMarker = require('js-rich-marker');
                // let content1 = '<div class="main" style="width: 60px; height: 60px; border: 3px solid grey; border-radius: 5px;"><div style="background-color:white;"><img style="width:54px;height:45px;" src=""></div><div style="background-color: white; display: flex; justify-content: space-around; height: 6px;"><p style="margin-top: -3px;font-size: 8px;">Pl 17 +2s</div></div>'
                // let content2 = '<div class="main" style="width: 70px; height: 70px; border: 3px solid grey; border-radius: 5px;"><div style="background-color:white;"><img style="width:64px;height:50px;" src=""></div><div style="background-color: white; display: flex; justify-content: space-around; height: 11px;"><p style="margin-top: -3px;">Pl 17 +2s</div></div>'
                // let marker1 = new RichMarker.RichMarker({
                //     position: position,
                //     map:map,
                //     shadow: 'none',
                //     dragable: true,
                //     content: content1
                // });
                let image = {
                    url: 'assets/imgs/marker/pulsing_marker.gif',
                    size: new google.maps.Size(32, 32),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(16, 16)
                };
                this.marker = new google.maps.Marker({
                    position: position,
                    map: map,
                    icon: image,
                    optimized: false
                });
            } else {
                this.marker.setPosition(position);
            }
            this.setMapCenter(o);
        }
    }

    flyTo(location: any) {
        this.setMapCenter(location);
    }

    positionNearestCompetitors(competitor) {

        console.log('ss-1')
        //bohdan
        if (this.getMap() && competitor.length == 1 && competitor[0].position == "right") {
            this.deleteMarkers();

            let position2 = new google.maps.LatLng(competitor[0].coords.latitude, competitor[0].coords.longitude);
            let map = this.getMap();

            // let RichMarker = require('js-rich-marker');
            let content2 = '<div class="main" style="width: 60px; height: 60px; border: 3px solid grey; border-radius: 5px;"><div style="background-color:white;"><img style="width:54px;height:45px;" src="' + competitor[0].image + '"></div><div style="background-color: white; display: flex; justify-content: space-around; height: 6px;"><p style="margin-top: -3px;font-size: 8px;">Pl ' + competitor[0].place + '  ' + competitor[0].time + 's</div></div>'

            let marker = new RichMarker.RichMarker({
                position: position2,
                map: map,
                shadow: 'none',
                dragable: true,
                content: content2
            });

            this.nearestCompetitors.push(marker);

            let myOverlay = new google.maps.OverlayView();
            myOverlay.draw = function () {
                this.getPanes().markerLayer.id = 'markerLayer';
            };
            myOverlay.setMap(map);
        }

        console.log('ss-2');
        if (this.getMap() && competitor.length == 1 && competitor[0].position == "left") {

            this.deleteMarkers();

            let position1 = new google.maps.LatLng(competitor[0].coords.lat(), competitor[0].coords.lng());
            let map = this.getMap();

            // let RichMarker = require('js-rich-marker');
            let content1 = '<div class="main" style="width: 60px; height: 60px; border: 3px solid grey; border-radius: 5px;"><div style="background-color:white;"><img style="width:54px;height:45px;" src="' + competitor[0].image + '"></div><div style="background-color: white; display: flex; justify-content: space-around; height: 6px;"><p style="margin-top: -3px;font-size: 8px;">Pl ' + competitor[0].place + '  ' + competitor[0].time + 's</div></div>'

            let marker = new RichMarker.RichMarker({
                position: position1,
                map: map,
                shadow: 'none',
                dragable: true,
                content: content1
            });


            this.nearestCompetitors.push(marker);

            let myOverlay = new google.maps.OverlayView();
            myOverlay.draw = function () {
                this.getPanes().markerLayer.id = 'markerLayer';
            };
            myOverlay.setMap(map);
        }

        console.log('ss-3');
        if (this.getMap() && competitor.length == 2) {

            this.deleteMarkers();

            let position1 = new google.maps.LatLng(competitor[0].coords.latitude, competitor[0].coords.longitude);
            let position2 = new google.maps.LatLng(competitor[1].coords.lat(), competitor[1].coords.lng());

            let map = this.getMap();

            // let RichMarker = require('js-rich-marker');
            let content1 = '<div class="main" style="width: 60px; height: 60px; border: 3px solid grey; border-radius: 5px;"><div style="background-color:white;"><img style="width:54px;height:45px;" src="' + competitor[0].image + '"></div><div style="background-color: white; display: flex; justify-content: space-around; height: 6px;"><p style="margin-top: -3px;font-size: 8px;">Pl ' + competitor[0].place + '  ' + competitor[0].time + 's</div></div>'
            let content2 = '<div class="main" style="width: 60px; height: 60px; border: 3px solid grey; border-radius: 5px;"><div style="background-color:white;"><img style="width:54px;height:45px;" src="' + competitor[1].image + '"></div><div style="background-color: white; display: flex; justify-content: space-around; height: 6px;"><p style="margin-top: -3px;font-size: 8px;">Pl ' + competitor[1].place + '  ' + competitor[1].time + 's</div></div>'
            let marker1 = new RichMarker.RichMarker({
                position: position1,
                map: map,
                shadow: 'none',
                dragable: true,
                content: content1
            });

            let marker2 = new RichMarker.RichMarker({
                position: position2,
                map: map,
                shadow: 'none',
                dragable: true,
                content: content2
            });

            this.nearestCompetitors.push(marker1);

            this.nearestCompetitors.push(marker2);

            let myOverlay = new google.maps.OverlayView();
            myOverlay.draw = function () {
                this.getPanes().markerLayer.id = 'markerLayer';
            };
            myOverlay.setMap(map);
        }

    }

    preloadMap(path) {
        console.log("warning: no preloading feature is implemented for google maps...");
    }

    // Sets the map on all markers in the array.
    setMapOnAll(map) {
        for (let i = 0; i < this.nearestCompetitors.length; i++) {
            this.nearestCompetitors[i].setMap(map);
        }
    }

    // Removes the markers from the map, but keeps them in the array.
    clearMarkers() {
        this.setMapOnAll(null);
    }

    clearNearestMarkers() {
        if (this.startMarker) {
            this.startMarker.setMap(null);
            this.startMarker = null;
        }
        if (this.finishMarker) {
            this.finishMarker.setMap(null);
            this.finishMarker = null;
        }
    }

    // Shows any markers currently in the array.
    showMarkers() {
        this.setMapOnAll(this.getMap());
    }

    // Deletes all markers in the array by removing references to them.
    deleteMarkers() {
        this.clearMarkers();
        this.nearestCompetitors = [];
    }

    setMapCenter(o) {
        let position = new google.maps.LatLng(o.coords.latitude, o.coords.longitude);
        if (this.getMap()) {
            // google.maps.event.trigger(this.getMap(), 'resize');

            this.getMap().setCenter(position);
            //Smoother
            // this.getMap().panTo(position);
            this.getMap().setZoom(18);
        }
    }

    setMapCenterLatLng(coords, zoom: number = 18) {
        this.getMap().setCenter(coords);

        this.getMap().setZoom(zoom);
    }

    drawPolyLines(isCustom: boolean = false) {
        if (this.getMap()) {
            if (this.getPolyLines()) {
                this.getPolyLines().setMap(null);
                delete this.config.polyLines;
            }
            this.setPolyDraw(isCustom);
        }
    }

    setMap(map) {
        console.log('setMap: ' + map);
        GoogleMapsProduct.map = map;
    }

    getMap() {
        console.log('getMap: ' + GoogleMapsProduct.map);
        return GoogleMapsProduct.map;
    }

    getCenter() {
        return GoogleMapsProduct.map.getCenter();
    }

    // isCentered(o) {
    //     let position = new google.maps.LatLng(o.coords.latitude, o.coords.longitude);

    //     let allowedBounds = new google.maps.LatLngBounds(
    //         new google.maps.LatLng(o.coords.latitude - 5, o.coords.longitude - 5),
    //         new google.maps.LatLng(o.coords.latitude + 5, o.coords.longitude + 5)
    //     );
    //     if (allowedBounds.contains(position)) {
    //         return true;
    //     } else {
    //         return false;
    //     }
    // }

    async setPolyDraw(isCustom) {
        let array = this.getPolyDestinations();
        let polyOptions = {
            path: array,
            strokeColor: "#294f94",
            strokeOpacity: 1.0,
            strokeWeight: 2,
        };
        this.config.polyLines = new google.maps.Polyline(polyOptions);
        this.getPolyLines().setMap(this.getMap());
    }

    getPolyLines() {
        return this.config.polyLines;
    }

    setPolyDestinations(o) {
        this.config.polyDestinations = Object.assign([], o);
    }

    getPolyDestinations() {
        return this.config.polyDestinations;
    }

    drawStartFinishMarkersLatLng(coords, icons) {
    }

    drawStartFinishMarkersArray(coords, icons) {
    }

    disableZoom() {
        // not implemented...
    }

    setMapCenterZoom(zoon) {
        // not implemented...
    }

    removeAllPath() {
        // not implemented...
    }

    destroy() {
        GoogleMapsProduct.instance = null;
    }
}